import React from 'react';
import './ModelInfoPopup.css';

const ModelInfoPopup = (props) => {
    return(
        <div className="pF t0 l0 r0 b0 mA mxw480 p16 bgF oS br4" style={{"width": "90vw", "height": "90vh"}}>
            <div className="wp100 taR">
                <div onClick={props.toggleModelInfoPopup} className="c8 fw500 pr6 dIb vM">Close</div>
                <div className="dIb vM">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.11771 5L4.99904 5.12187L5.11771 5ZM5.11771 5L4.99904 4.87813L5.38185 4.48317L4.99904 4.87813L5.11771 5ZM5.11771 5L9 1L5.11771 5ZM5.11771 5L9 9L5.11771 5ZM4.88101 5L1 1L4.88101 5ZM4.88101 5L4.99968 4.87813L4.88101 5ZM4.88101 5L4.99968 5.12187L4.61688 5.51683L4.99968 5.12187L4.88101 5ZM4.88101 5L1 8.99936L4.88101 5ZM4.99968 5.12187L5.38249 5.51683L4.99968 5.12187ZM4.61688 4.48381L4.99968 4.87877L4.61688 4.48381Z" stroke="#888888" strokeWidth="2"/>
                    </svg>
                </div>
            </div>
            {(props.model_info && Object.keys(props.model_info).map((key, index) => {
                return(
                <div key={"model_"+key+"_"+index} className="taL">
                    <div className="pt12 fs13 fwB lh18 taC tdU ttU">Model {index+1} Details</div>
                    <div className="pt4 fs12 lh16">
                    {props.model_info[key].map((term, index) => {
                        return(<div className="pt4" key={"model_data_"+index}><span className="fwB">{index+1}.&nbsp;&nbsp;</span>{term.option}</div>)
                    })}
                    </div>
                </div>);
            }))}
        </div>
    );
}

export default ModelInfoPopup;
